(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('tyallsApp')
        .constant('VERSION', "1.13.0-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
